import { render, staticRenderFns } from "./TeaserText.vue?vue&type=template&id=55857e74&"
import script from "./TeaserText.vue?vue&type=script&lang=ts&"
export * from "./TeaserText.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports